(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    const setupNewsletterPopup = () => {
  const popup = document.getElementById('NewsletterPopup');
  if (!popup || popup.dataset.bound) return;
  popup.dataset.bound = 'true';
  let lastFocusedElement;
  const sessionKey = 'zarrii-newsletter-seen';
  const open = () => {
    if (popup.open || typeof popup.showModal !== 'function') return;
    lastFocusedElement = document.activeElement;
    popup.showModal();
    popup.querySelector('[data-newsletter-popup-close]').focus();
  };
  const close = () => {
    if (!popup.open) return;
    popup.close();
    if (lastFocusedElement instanceof HTMLElement && lastFocusedElement !== document.body) lastFocusedElement.focus();
  };
  document.querySelectorAll('[data-newsletter-popup-open]').forEach(button => button.addEventListener('click', open));
  popup.querySelector('[data-newsletter-popup-close]').addEventListener('click', close);
  popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
  popup.addEventListener('click', event => { if (event.target === popup) close(); });
  if (location.hash === '#NewsletterPopupForm' && popup.querySelector('[data-newsletter-response]')) {
    try { sessionStorage.setItem(sessionKey, '1'); } catch (error) {}
    open();
    return;
  }

};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupNewsletterPopup, { once: true });
else setupNewsletterPopup();
  } catch(e) { console.error(e); }
})();

})();
